export enum AgentStatus {
  AWAITING_INPUT = "awaiting-input",
  WORKING = "working",
  COMPLETED = "completed",
  FAILED = "failed",
  QUEUED = "queued",
}

export interface AgentRun {
  runId: string;
  taskName: string;
  taskId: string;
  auditName: string;
  auditId: string;
  agentStatus: AgentStatus;
  startedAt: string;
  lastUpdated: string;
  assignee: string;
  description: string;
}

export interface GetAgentRunsRequest {
  teamName: string;
}

export interface GetAgentRunsResponse {
  runs: AgentRun[];
  totalCount: number;
}

export interface GetAgentRunStatsRequest {
  teamName: string;
}

export interface GetAgentRunStatsResponse {
  awaitingInput: number;
  failed: number;
  inProgress: number;
  completed: number;
}
